import { AuthError, isAuthError } from '@supabase/supabase-js';

export const useHandleSupabaseError = (error: AuthError): string => {
  if (!isAuthError(error)) {
    return 'composables.handleError.unknownError';
  } else return error.message;
};
